import { useMutation } from '@tanstack/react-query';

import restfulClient from '@src/utils/restfulClient';

interface sendEmailLinkParams {
	email: string;
}

export async function sendEmailLink({ email }: sendEmailLinkParams) {
	const route = 'bbff/identity/start-email-link-login';

	const data = {
		Email: email,
	};

	try {
		const response = await restfulClient.post({
			route,
			data,
		});

		return response;
	} catch (error) {
		if (error instanceof Error) {
			throw new Error(error.message);
		} else {
			throw new Error('Apologies, we are facing technical issues; please try again later.');
		}
	}
}

export function useEmailLogin() {
	const { error, isPending, mutate } = useMutation<any, Error, any>({
		mutationKey: ['sendEmailLink'],
		mutationFn: (body) => sendEmailLink(body),
	});

	const emailLoginMutation = (body: any) => {
		return new Promise((resolve, reject) => {
			mutate(body, {
				onSuccess: resolve,
				onError: reject,
			});
		});
	};

	return { error, isPending, emailLoginMutation };
}
